module.exports = __webpack_public_path__ + "img/15-1_Sigmoid.caa05457.png";